import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { select, Store } from '@ngrx/store';
import { selectMenuVisible } from '@store/selectors/component.selectors';
import { AsyncPipe } from '@angular/common';
import { toggleMenu } from '@store/actions/component.actions';
import { Avatar, AvatarModule } from 'primeng/avatar';
import { Ripple } from 'primeng/ripple';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Route } from '@modules/shared/app.routes';
import { filter, Observable } from 'rxjs';
import { Translation } from '@modules/shared/i18n/translation.interface';
import { TranslationService } from '@modules/shared/services/translation.service';
import { selectActiveWebshop } from '@store/selectors/webshop.selectors';
import { Webshop } from '@models/webshop.model';
import { selectMe } from '@store/selectors/customer.selectors';
import { Customer } from '@models/customer.model';

import { AppButtonComponent } from '@components/wrappers/button/button.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  imports: [
    AsyncPipe,
    Avatar,
    Ripple,
    DrawerModule, ButtonModule, Ripple, AvatarModule, RouterLink, RouterLinkActive,
    AppButtonComponent
  ],
  styleUrl: './menu.component.scss'
})
export class MenuComponent {

  visible = true;
  private readonly store = inject(Store);
  protected visible$ = this.store.pipe(select(selectMenuVisible));
  protected webshop$: Observable<Webshop | undefined> = this.store.select(selectActiveWebshop);
  protected me$: Observable<Customer | null> = this.store.select(selectMe);
  public translation!: Translation;
  private readonly translationService = inject(TranslationService);
  private translation$ = this.translationService.getTranslation();

  constructor() {
    this.translation$
      .pipe(
        filter((val) => val !== undefined),
        takeUntilDestroyed()
      )
      .subscribe((translation) => (this.translation = translation));
  }

  public getUser(me: Customer | null): string {
    if (me) {
      return `${me.firstname} ${me.lastname}`;
    }
    return '';
  }

  protected toggleMenu() {
    this.store.dispatch(toggleMenu());
  }

  protected readonly Route = Route;
}
